import React from 'react'
import { Button, IconButton, Menu, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { NavLink } from 'react-router-dom'
import { formatRoute } from 'react-router-named-routes'
import { NamedRoutes } from '../../../../routes'
import { TableRowBackground } from '../../../../utils/colors'
import { useStyles } from './Styles'
import DeletePromocode from './DeletePromocode'

const PromocodeMenu = ({ index, data, setData, count, setCount, handleNotificationCall }) => {
  let classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [viewPageMenu, setViewPageMenu] = React.useState(false)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setViewPageMenu(true)
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setViewPageMenu(false)
  }

  const StyledMenu = withStyles({
    paper: {
      border: `1px solid ${TableRowBackground}`
    }
  })((props) => (
    <Menu
      elevation={4}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      disableScrollLock
      {...props}
    />
  ))

  const [viewDeletePromocodeDialog, setViewDeletePromocodeDialog] = React.useState(false)
  const [openDeletePromocodeDialog, setOpenDeletePromocodeDialog] = React.useState(false)
  const handleDeletePromocodeDialog = () => {
    if (!openDeletePromocodeDialog) {
      setViewDeletePromocodeDialog(true)
    } else {
      setTimeout(() => setViewDeletePromocodeDialog(false), 500)
    }
    setOpenDeletePromocodeDialog(!openDeletePromocodeDialog)
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon/>
      </IconButton>
      {!!viewPageMenu &&
      <StyledMenu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        className={classes.PromocodeCustomMenu}
      >
        <MenuItem onClick={handleClose}>
          <NavLink to={formatRoute(NamedRoutes.subscription.promocodes.edit, { id: data[index].id })}>
            <FormattedMessage id='UserMenu.editPage'/>
          </NavLink>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Button color="primary" onClick={handleDeletePromocodeDialog}>
            <FormattedMessage id='UserMenu.deletePage'/>
          </Button>
        </MenuItem>
      </StyledMenu>
      }
      <DeletePromocode
        index={index}
        data={data}
        setData={setData}
        count={count}
        setCount={setCount}
        handleNotificationCall={handleNotificationCall}
        handleDeletePromocodeDialog={handleDeletePromocodeDialog}
        viewDeletePromocodeDialog={viewDeletePromocodeDialog}
        openDeletePromocodeDialog={openDeletePromocodeDialog}/>
    </div>
  )
}

export default PromocodeMenu

